import styled, { css } from "styled-components";
import downloadStartedHeroPng from "./assets/download-started-hero.png";

export const Header = styled.div`
  ${(props) => props.theme.HeaderDefault}
  background-image: url(${downloadStartedHeroPng});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  min-height: 250px;
  padding-top: 50px;
  padding-bottom: 50px;

  .video-element {
    text-align: center;
  }
`;

export const Description = styled.div`
  font-size: 32px;
  font-weight: 700;
  line-height: 39px;
  letter-spacing: -0.02em;
  text-align: center;
  max-width: 456px;
  margin: auto;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: center;
  display: inline-block;
  vertical-align: top;
  padding: 14px 0 0 10px;
`;

export const Logo = styled.div`
  text-align: center;
  margin-bottom: 20px;

  img {
    height: 48px;
    width: auto;
    vertical-align: unset;
  }
`;

export const BoxContainer = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 30px;
  padding-bottom: 15px;
  -webkit-font-smoothing: antialiased;
  .col-sm-8 {
    padding-left: 10px;
    padding-right: 10px;
  }
  .col-xs-24 img {
    width: 100%;
    height: auto;
  }
  .noPadingLeft {
    padding-left: 0;
    @media (max-width: ${(props) => props.theme.Breakingpoint.sm}px) {
      padding-left: 15px;
    }
    .boxLinuxImg {
      max-width: 100%;
      border-radius: 0;
      -webkit-border-top-right-radius: 8px;
      -webkit-border-bottom-right-radius: 8px;
      -moz-border-radius-topright: 8px;
      -moz-border-radius-bottomright: 8px;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      @media (max-width: ${(props) => props.theme.Breakingpoint.sm}px) {
        max-width: 607px;
        border-radius: 0;
        -webkit-border-bottom-right-radius: 8px;
        -webkit-border-bottom-left-radius: 8px;
        -moz-border-radius-bottomright: 8px;
        -moz-border-radius-bottomleft: 8px;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
      }
    }
  }
  .noPadingRight {
    .boxLinuxText {
      max-width: 100%;
      border-radius: 0;
      -webkit-border-top-left-radius: 8px;
      -webkit-border-bottom-left-radius: 8px;
      -moz-border-radius-topleft: 8px;
      -moz-border-radius-bottomleft: 8px;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      padding-top: 20px;
      @media (max-width: ${(props) => props.theme.Breakingpoint.sm}px) {
        border-radius: 0;
        -webkit-border-top-left-radius: 8px;
        -webkit-border-top-right-radius: 8px;
        -moz-border-radius-topleft: 8px;
        -moz-border-radius-topright: 8px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        margin-bottom: 0;
        padding-right: 15px;
        max-width: 607px;
      }
    }
    padding-right: 0;
    @media (max-width: ${(props) => props.theme.Breakingpoint.sm}px) {
      padding-right: 15px;
    }
  }
`;

const grids = (size) => {
  return css`
    width: ${100 / size}%;
  `;
};

export const BoxItem = styled.div`
  /* flex: 1; */
  position: relative;
  border-radius: 8px;
  background: #fafafa;
  min-height: 334px;
  max-height: 425px;
  height: auto;
  margin-bottom: 20px;
  overflow: hidden;

  ${(props) => {
    return props.grid && grids(props.grid);
  }};
  @media (max-width: ${(props) => props.theme.Breakingpoint.sm}px) {
    &.sm-half {
      ${(props) => {
        return props.grid && grids(props.grid / 2);
      }};
    }
  }

  @media (max-width: ${(props) => props.theme.Breakingpoint.md}px) {
    margin: 0 auto 20px auto;
    max-width: 313px;
  }

  .imageLinux {
    border-radius: 0;
  }

  .imageLinux img {
    min-height: 225px;
    width: auto;
    @media (max-width: ${(props) => props.theme.Breakingpoint.md}px) {
      min-height: 225px;
      width: auto;
      margin: auto;
    }
  }
  .imageMac img {
    max-height: 150px;
    height: 100%;
    width: auto;

    @media (max-width: ${(props) => props.theme.Breakingpoint.md}px) {
      min-height: 210x;
      width: auto;
      margin: auto;
    }
  }
  .imageWin img {
    min-height: 150px;
    width: auto;
    @media (max-width: ${(props) => props.theme.Breakingpoint.md}px) {
      min-height: 150px;
      width: auto;
      margin: auto;
    }
  }
`;

export const BoxItemImage = styled.div`
  text-align: auto;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;
`;

export const BoxItemTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #212124;
`;

export const BoxItemDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: -0.02em;
  text-align: center;
  color: #6b6d76;
  padding: 20px 24px 10px 24px;
`;

export const BoxItemStep = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #6b6d76;
  padding-top: 30px;
  padding-bottom: 5px;
`;

export const BoxItemLink = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: -0.02em;
`;

export const BoxItemUrl = styled.a`
  color: #006fff;
  text-decoration: underline;
  :hover {
    color: #006fff;
  }
`;

export const BoxFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px 15px 75px;
  gap: 75px;

  @media (max-width: ${(props) => props.theme.Breakingpoint.md}px) {
    gap: 40px;
  }

  @media (max-width: ${(props) => props.theme.Breakingpoint.sm}px) {
    flex-direction: column-reverse;
    gap: 60px;
  }
`;

export const FooterImage = styled.img`
  @media (max-width: ${(props) => props.theme.Breakingpoint.sm}px) {
    max-width: 100%;
    height: auto;
  }
`;

export const BoxBarcodeWrapper = styled.div`
  display: flex;
  padding-top: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #212124;
  align-items: center;
  text-align: left;
  margin-left: -7px;

  img {
    width: 110px;
    height: 110px;
    margin-right: 20px;
  }

  span {
    max-width: 160px;
  }
`;

export const BoxText1 = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  letter-spacing: -0.02em;
  color: #6b6d76;
  padding-bottom: 5px;
`;
export const BoxText2 = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: left;
  letter-spacing: -0.02em;
  color: #212124;
  padding-bottom: 10px;
`;
export const BoxText3 = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #6b6d76;
  max-width: 265px;
  text-align: left;
`;
